module.exports = __webpack_public_path__ + "4368bc28438754226436fbb99352564c.png";